import { Alert } from "@/components/ui/Alert";
import { Divider } from "@/components/ui/Divider";
import { config } from "@/config";
import { AdfsLoginForm, type AdfsLoginFormVariant } from "@/pages/LoginPage/AdfsLoginForm";
import styles from "@/pages/LoginPage/LoginPage.module.css";
import { LoginPageLogo } from "@/pages/LoginPage/LoginPageLogo";
import { LoginPageTitle } from "@/pages/LoginPage/LoginPageTitle";
import { MicrosoftLoginButton } from "@/pages/LoginPage/MicrosoftLoginButton";

type Props = {
    isErrorUserNotFound?: boolean;
};

const LoginPage = ({ isErrorUserNotFound }: Props) => {
    const showMicrosoftLogin = config.AZURE_AUTH_ENABLED;
    const showAdfsLogin = config.ADFS_AUTH_ENABLED;
    const showDivider = showMicrosoftLogin && showAdfsLogin;
    const adfsLoginVariant: AdfsLoginFormVariant = showMicrosoftLogin ? "buttonAndForm" : "form";

    return (
        <div>
            <div className={styles.image} />
            <div className={styles.panel}>
                <div className={styles.panel_content}>
                    <LoginPageLogo />
                    <LoginPageTitle />
                    <div className={styles.login_method_list}>
                        {isErrorUserNotFound && (
                            <Alert severity="error">
                                We are sorry but you do not have an account in the LSSA, please{" "}
                                <b>contact your manager / cluster</b>.
                            </Alert>
                        )}
                        {showMicrosoftLogin && <MicrosoftLoginButton />}
                        {showDivider && (
                            <div className={styles.login_method_divider}>
                                <Divider className={styles.login_method_divider_hr} />
                                <span className={styles.login_method_divider_text}>or</span>
                                <Divider className={styles.login_method_divider_hr} />
                            </div>
                        )}
                        {showAdfsLogin && <AdfsLoginForm variant={adfsLoginVariant} />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export { LoginPage };
